export default "__VITE_ASSET__DlfsLyLb__"